<header>
  <h1>
    Organisation Admin
    <button
      (click)="addNewOrg()"
      color="primary"
      mat-mini-fab
      matTooltip="Create organisation."
      >
      <mat-icon>add</mat-icon>
    </button>
  </h1>
  <search-text (search)="setSearch($event)"></search-text>
</header>

<section class="organisations">
  @if (loading) {
    <mat-card class="loading">
      <mat-card-content>
        <mat-icon>autorenew</mat-icon>
        Loading&hellip;
      </mat-card-content>
    </mat-card>
  }
  @if (!loading) {
    @if (!Organisations?.length) {
      <mat-card class="no-results">
        <mat-card-content>
          <mat-icon>sentiment_dissatisfied</mat-icon>
          No organisations found
        </mat-card-content>
      </mat-card>
    }
    @if (!!Organisations.length) {
      <table mat-table [dataSource]="DataSource" class="organisation">
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Organisation</th>
          <td mat-cell *matCellDef="let row">{{row.title}}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row" class="actions">
            @if (row.filter == 'club' || row.filter == 'network' || row.slug == 'the-odney-club') {
              <button
                (click)="listMembers(row)"
                mat-button
                matTooltip="List organisation members."
                >
                <mat-icon>people</mat-icon>
              </button>
            }
            <a
              [href]="leisureUrl + '/company/' + row.slug"
              mat-button
              matTooltip="View organisation."
              target="_blank"
              >
              <mat-icon>visibility</mat-icon>
            </a>
            @if (isSuperAdmin) {
              <button
                (click)="viewAccountCode(row)"
                mat-button
                matTooltip="Manage account code."
                >
                <mat-icon>currency_pound</mat-icon>
              </button>
            }
            <button
              (click)="viewOrganisation(row)"
              mat-button
              matTooltip="Manage organisation page."
              >
              <mat-icon>settings</mat-icon>
            </button>
            @if (row.company_id == 176) {
              <button
                (click)="downloadOrderReport(row)"
                mat-button
                matTooltip="Download order report."
                >
                <mat-icon>download</mat-icon>
              </button>
            }
          </td>
        </ng-container>
      </table>
      @if (PageEvent) {
        <mat-paginator
          (page)="DataSource.loadWithPageEvent($event)"
          [length]="PageEvent.length"
          [pageIndex]="PageEvent.pageIndex"
          [pageSize]="PageEvent.pageSize"
        ></mat-paginator>
      }
    }
  }
</section>
